import ApplicationAdapter from "./application";

export default class InviteAdapter extends ApplicationAdapter {
  urlForFindRecord(id) {
    return `${this.apiBaseUri}/invite/show?invitecode=${id}`;
  }
}
